import type { FC } from "react";

import { cn } from "../../utils";
import { Group, type GroupProps } from "../group";

export const EditorToolbar: FC<GroupProps> = ({ className, ...props }) => (
  <Group
    type="flex"
    direction="row"
    className={cn("gap-0 items-center max-w-full overflow-x-auto py-2", className)}
    {...props}
  />
);
